import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { normalizeLang } from '@/mocks/sections';
import { resolveSeo, applySeoMeta, applyNoindex, SITE_URL, SITE_NAME } from '@/lib/seo';
import {
  buildWebSiteSchema,
  buildArticleSchema,
  buildBreadcrumbSchema,
  injectJsonLd,
  clearJsonLd,
} from '@/lib/schema';

const JSON_LD_IDS = ['seo-website', 'seo-article', 'seo-breadcrumb'];

export default function SeoManager() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang = normalizeLang(i18n.language);

  useEffect(() => {
    const resolved = resolveSeo(pathname, lang);

    clearJsonLd(JSON_LD_IDS);

    if (!resolved.meta) {
      applyNoindex();
      return;
    }

    applySeoMeta(resolved.meta);

    if (resolved.route === 'home') {
      injectJsonLd('seo-website', buildWebSiteSchema(resolved.meta.ogUrl, lang));
    } else if (resolved.route === 'article' && resolved.article) {
      const url = resolved.meta.ogUrl;
      injectJsonLd('seo-article', buildArticleSchema(resolved.article, url, lang));
      injectJsonLd(
        'seo-breadcrumb',
        buildBreadcrumbSchema([
          { name: SITE_NAME, url: `${SITE_URL}/` },
          { name: resolved.article.title, url },
        ]),
      );
    }
  }, [pathname, lang]);

  return null;
}